/**
 * The leads' cache root and the one lead read two pages share: the newest page not yet converted,
 * which the roster's „Zgłoszenia" button counts. The inbox's own reads stay in
 * `pages/public-form-leads/api/leadQueries.ts` under the same root, so a write there (viewed,
 * converted, deleted) invalidates this count with them.
 */

import { queryOptions } from '@tanstack/react-query';

import { getPublicFormsLeads } from '~/shared/api/generated/endpoints/public-form-leads/public-form-leads';

export const leadsRoot = ['public-form-leads'] as const;

/**
 * The newest page of leads not yet converted, for the navigation's count of unopened ones. The
 * backend offers no count, so the badge counts within one page (25 leads): enough to say that
 * something is new, which is all the badge is for.
 */
export function newLeadsQueryOptions() {
  return queryOptions({
    queryKey: [...leadsRoot, 'submitted-first-page'] as const,
    queryFn: ({ signal }) => getPublicFormsLeads({ status: 'submitted' }, undefined, signal),
    staleTime: 60 * 1000,
  });
}
